import React, { useId, useRef, useEffect, useState } from "react";
import {
  Typography,
  Card,
  Stack,
  Box,
  TextField,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Button,
  ButtonBase,
  Popover, 
  Dialog,
  DialogTitle,
  DialogActions,
    DialogContent,
    DialogContentText,
    IconButton

} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";






export default function TermsAndConditions ({open, onClose}) {
  return (
    <Dialog open={open} onClose={onClose}
        sx={{
            "& .MuiDialog-paper": {

            borderRadius: "8px",
            fontFamily: "'Lato', sans-serif",
            padding: 4,
                 minWidth: "700px",
                 backgroundColor: "#F7FBFC",
                              borderRadius: "13px",

            },
        }}
        PaperProps={{
            sx: {
            backgroundColor: "#F7FBFC",
            color: "#333",
             minWidth: "700px",
             borderRadius: "13px",
            },
        }}
    
    >
<DialogTitle sx={{ justifyContent: "center" }}>
   <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 4,
            top: 7,
            color: "#7589A2",
            backgroundColor: "transparent",
            zIndex: 1,
            borderRadius: "12px",
            width: "35px",
            height: "35px",
            padding: "3px",
            mx: 0.5,
            my: 0.25,
          }}
        >
          <CloseIcon sx={{ fontSize: "28px" }} />
        </IconButton>
  <Box>
    <Typography
      variant="h4"
      gutterBottom
      align="center"
      sx={{ fontWeight: 'bold', fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px' }}
    >
      Terms of Service
    </Typography>

    <Typography
      variant="body2"
      align="center"
      gutterBottom
      sx={{ fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.2px' }}
    >
      Last updated: July 7, 2025
    </Typography>
  </Box>
</DialogTitle>
      <DialogContent>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Acceptance of Terms
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          By accessing or using this application (“NanoNotify”), you agree to be bound by these Terms and Conditions (“Terms”). If you do not agree to these Terms, please do not use NanoNotify.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Modifications
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          We reserve the right to change or modify these Terms at any time. Any changes will be effective immediately upon posting. Your continued use of NanoNotify constitutes your acceptance of the revised Terms.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          User Accounts
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          You may be required to create an account to access certain features of NanoNotify. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Use of the App
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          You agree not to use NanoNotify for any unlawful or prohibited activities. You may not attempt to gain unauthorized access to any part of NanoNotify or any other systems or networks connected to NanoNotify.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Intellectual Property
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          All content, trademarks, logos, and other intellectual property displayed in NanoNotify are the property of their respective owners. You may not use, copy, reproduce, or distribute any content from the App without prior written permission.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Termination
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465'}}>
          We reserve the right to suspend or terminate your access to NanoNotify at our sole discretion, without notice, for conduct that we believe violates these Terms or is harmful to other users of NanoNotify, us, or third parties.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Disclaimer of Warranties
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          NanoNotify is provided “as is” and “as available” without warranties of any kind, either express or implied. We do not guarantee that NanoNotify will be error-free or uninterrupted.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          Limitation of Liability
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465', letterSpacing: '-0.3px'}}>
          To the maximum extent permitted by law, we shall not be liable for any indirect, incidental, special, or consequential damages resulting from your use of or inability to use NanoNotify.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465',letterSpacing: '-0.3px'}}>
          Governing Law
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465',letterSpacing: '-0.3px'}}>
          These Terms are governed by and construed in accordance with the laws of your jurisdiction. Any disputes arising from these Terms or your use of NanoNotify shall be resolved in the appropriate courts of that jurisdiction.
        </Typography>
      </Box>

      <Box sx={{ mt: 1 }}>
        <Typography variant="h6" gutterBottom sx={{fontFamily: "'Lato', sans-serif", color:'#395465',letterSpacing: '-0.3px'}}>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph sx={{fontFamily: "'Lato', sans-serif", color:'#395465',letterSpacing: '-0.3px'}}>
          If you have any questions or concerns about these Terms, please contact us at info@NanoNotify.com.
        </Typography>
      </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
      </DialogActions>
    </Dialog>
  );
}